import styled from 'styled-components'

export const StyledDetail = styled.div``
